let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("17HOU")).then(() => parcelRequire('dAxUw'));